import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import { FaPalette } from "react-icons/fa";
import { FaThLarge } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { ArtContext } from "../Contexts/ArtContext";
import { ArtistContext } from "../Contexts/ArtistContext";
import { CategoryContext } from "../Contexts/CategoryContext";
import { CollectionContext } from "../Contexts/CollectionContext";
import { TeamContext } from "../Contexts/TeamContext";

const AdminDash = () => {
  const { team, fetchTeam } = useContext(TeamContext);
  const { allArts, fetchArts } = useContext(ArtContext);
  const { allCollections, fetchCollections } = useContext(CollectionContext);
  const { category, fetchCategories } = useContext(CategoryContext);
  const { artists, fetchArtists } = useContext(ArtistContext);

  const totalArtists = artists.length;
  const totalTeam = team.length;
  const totalArts = allArts.length;
  const totalCollection = allCollections.length;
  const totalCategory = category.length;

  const cardStyles =
    "flex items-center p-6 rounded-lg shadow-lg transform transition-transform hover:scale-105";
  const iconStyles = "text-5xl text-secondary mr-4";

  useEffect(() => {
    const fetchData = async () => {
      // Check if data is already fetched
      if (!artists.length) await fetchArtists();
      if (!category.length) await fetchCategories();
      if (!allCollections.length) await fetchCollections();
      if (!team.length) await fetchTeam();
      if (!allArts.length) await fetchArts();
    };
    fetchData();
  }, []);

  return (
    <div className="p-8 bg-white min-h-screen rounded-lg">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold mb-8 text-black text-center">
          Welcome Back!
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Total number of artists */}
          <Link
            to="/admin/view/artists"
            className={`${cardStyles} bg-white no-underline`}
          >
            <FaUsers className={iconStyles} />
            <div>
              <p className="text-lg font-semibold text-primary">
                Total Artists
              </p>
              <p className="text-2xl font-bold text-secondary">
                {totalArtists}
              </p>
            </div>
          </Link>
          {/* Total number of team members */}
          <Link
            to="/admin/view/members"
            className={`${cardStyles} bg-white no-underline`}
          >
            <FaUsers className={iconStyles} />
            <div>
              <p className="text-lg font-semibold text-primary">
                Total Team Members
              </p>
              <p className="text-2xl font-bold text-secondary">{totalTeam}</p>
            </div>
          </Link>
          {/* Total number of arts */}
          <Link
            to="/admin/view/art"
            className={`${cardStyles} bg-white no-underline`}
          >
            <FaPalette className={iconStyles} />
            <div>
              <p className="text-lg font-semibold text-primary">Total Arts</p>
              <p className="text-2xl font-bold text-secondary">{totalArts}</p>
            </div>
          </Link>
          {/* Total number of collections */}
          <Link
            to="/admin/view/collections"
            className={`${cardStyles} bg-white no-underline`}
          >
            <FaThLarge className={iconStyles} />
            <div>
              <p className="text-lg font-semibold text-primary">
                Total Collections
              </p>
              <p className="text-2xl font-bold text-secondary">
                {totalCollection}
              </p>
            </div>
          </Link>
          {/* Total number of categories */}
          <Link
            to="/admin/view/categories"
            className={`${cardStyles} bg-white no-underline`}
          >
            <FaFolder className={iconStyles} />
            <div>
              <p className="text-lg font-semibold text-primary">
                Total Categories
              </p>
              <p className="text-2xl font-bold text-secondary">
                {totalCategory}
              </p>
            </div>
          </Link>
        </div>
        <div className="mt-12 text-center">
          <Link
            to="/admin/view/artists"
            className="inline-block px-8 py-4 bg-primary text-white rounded-lg shadow-lg hover:bg-secondary transition duration-300 transform hover:scale-105 no-underline"
          >
            Manage Artists
          </Link>
          <Link
            to="/admin/view/art"
            className="inline-block mt-4 md:mt-0 md:ml-4 px-8 py-4 bg-primary text-white rounded-lg shadow-lg hover:bg-secondary transition duration-300 transform hover:scale-105 no-underline ml-6"
          >
            Manage Arts
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDash;
